/**
 * theft from biksharing app
 *
 */


// colors
export const lightPrimaryColor = '#534bae';
export const darkPrimaryColor = '#000051';

export const primaryInvertColor = '#FFF';

export const lightSecondaryColor = '#60ad5e';
export const secondaryColor = '#2e7d32';
export const darkSecondaryColor = '#005005';

export const secondaryInvertColor = '#FFF';

export const lightTertiaryColor = '#EB5757';
export const tertiaryColor = '#b71c1c';
export const darkTertiaryColor = '#7f0000';

export const tertiaryInvertColor = '#FFF';

export const inactiveColor = '#cfd8dc';

export const inactiveInvertColor = '#37474f';

export const primaryBackgroundColor = '#FFF';
export const secondaryBackgroundColor = '#eceff1';

export const statusIconGreenColor = '#1faa00';
export const statusIconYellowColor = '#fbc02d';
export const statusIconRedColor = '#b71c1c';
export const statusIconGreyColor = '#78909c';

export const batteryLightGreenColor = statusIconGreenColor;
export const batteryLightYellowColor = statusIconYellowColor;
export const batteryLightRedColor = statusIconRedColor;

export const moreLightGreyColor = '#F4F6FA';
export const borderGreyColor = '#BEBECA';

export const dangerColor = '#d93333';
export const warningColor = '#F2994A';

export const lightGreyColor = 'rgba(45, 49, 66, 0.1)';
export const greyColor = '#546e7a';
export const darkGreyColor = '#263238';
export const primaryBorderColor = darkGreyColor;
export const greyColor1 = '#111';
export const greyColor2 = '#222';
export const greyColor3 = '#333';
export const greyColor4 = '#444';
export const greyColor5 = '#555';
export const greyColor6 = '#666';

export const transparent = 'rgba(255, 255, 255, 0)';

export const whiteOpacityColor1 = 'rgba(255, 255, 255, 0.1)';
export const whiteOpacityColor3 = 'rgba(255, 255, 255, 0.3)';
export const whiteOpacityColor5 = 'rgba(255, 255, 255, 0.5)';
export const whiteOpacityColor7 = 'rgba(255, 255, 255, 0.7)';
export const whiteOpacityColor9 = 'rgba(255, 255, 255, 0.9)';

export const blackOpacityColor1 = 'rgba(0, 0, 0, 0.1)';
export const blackOpacityColor3 = 'rgba(0, 0, 0, 0.3)';
export const blackOpacityColor5 = 'rgba(0, 0, 0, 0.5)';
export const blackOpacityColor7 = 'rgba(0, 0, 0, 0.7)';
export const blackOpacityColor8 = 'rgba(0, 0, 0, 0.8)';
export const blackOpacityColor9 = 'rgba(0, 0, 0, 0.9)';

export const mapMarkerGeoFenceFill = 'rgba(255, 0, 0, 0.1)';
export const mapMarkerGeoFenceStroke = 'rgba(255, 0, 0, 0.3)';
export const mapMarkerGeoFenceFillSelected = 'rgba(0, 255, 0, 0.2)';
export const mapMarkerGeoFenceStrokeSelected = 'rgba(0, 255, 0, 0.4)';
export const mapMarkerCurrentPositionPin = '#2c4998';

export const chambrayBlue = '#4C5980';
export const valhallaViolet = '#2D3142';
export const black = '#000';
export const deepBlue = '#7088D2';

// font sizes
export const smallTextSize = 12;
export const normalTextSize = 14;
export const largeTextSize = 18;

export const smallButtonTextSize = 17;
export const normalButtonTextSize = 20;
export const largeButtonTextSize = 24;

//component sizes
export const inputSize = 56;
export const iconButton = {
    height: 48,
    width: 48,
};
export const headerBarHeight = iconButton.height + 16;
export const SLIDE_HEIGHT = 550;
